import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const Routing = () => (
  <ComponentDocs name="<Routing/>" entry="Routing" propsEntry="RoutingProps">
    <ComponentExample
      name="Absolute routes"
      rawImport={import("examples/Routing/Routing/AbsoluteRoutesExample?raw")}
    />
    <ComponentExample
      name="Relative routes"
      rawImport={import("examples/Routing/Routing/RelativeRoutesExample?raw")}
    />
    <ComponentExample
      name="Route titles"
      rawImport={import("examples/Routing/Routing/RouteTitlesExample?raw")}
    />
  </ComponentDocs>
);

export default Routing;
